import React from "react";
import clsx from "clsx";

const statusStyles = {
  live: "bg-green-100 text-green-700",
  draft: "bg-gray-200 text-gray-700",
  unpublished: "bg-gray-200 text-gray-700",
  pending: "bg-yellow-100 text-yellow-800",
  archived: "bg-red-100 text-red-700",
};

export default function StatusBadge({ status }) {
  const formatted = status?.charAt(0)?.toUpperCase() + status?.slice(1);

  return (
    <span
      className={clsx(
        "text-xs font-medium px-3 py-[6px] rounded-md capitalize",
        statusStyles[status] || "bg-gray-100 text-gray-600"
      )}
    >
      {formatted}
    </span>
  );
}
